import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-documents-row',
  templateUrl: './skeleton-documents-row.component.html',
  styleUrls: ['./skeleton-documents-row.component.scss'],
  standalone: false
})
export class SkeletonDocumentsRowComponent {}
